import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './LoadingContent.styles';
import loadingStepImage from '@/media/onboarding/aiBuilder/loading-step.png';
import { ProgressBar } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

const LoadingContent = ({ locales }) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingTitle, setLoadingTitle] = useState(locales.loadingTitles[0]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;

  const updateTitleWithTransition = useCallback(({ newTitle = null, newProgress = null }) => {
    newTitle && setIsTransitioning(true);

    setTimeout(() => {
      newTitle && setLoadingTitle(newTitle);
      newProgress && setLoadingProgress(newProgress);

      setTimeout(() => {
        newTitle && setIsTransitioning(false);
      }, 150);
    }, 150);
  }, []);

  const updateLoadingProgress = useCallback(() => {
    const timeout1 = setTimeout(() => updateTitleWithTransition({ newProgress: 5 }), 5000);
    const timeout2 = setTimeout(() => updateTitleWithTransition({ newTitle: locales.loadingTitles[1], newProgress: 20 }), 8000);
    const timeout3 = setTimeout(() => updateTitleWithTransition({ newTitle: locales.loadingTitles[2], newProgress: 60 }), 15000);
    const timeout4 = setTimeout(() => updateTitleWithTransition({ newTitle: locales.loadingTitles[3], newProgress: 90 }), 25000);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      clearTimeout(timeout4);
    };
  }, [updateTitleWithTransition, locales.loadingTitles]);

  useEffect(() => {
    updateLoadingProgress();
  }, [updateLoadingProgress]);

  return (
    <Styles.LoadingWrapper data-testid="create-site-loading-content">
      <Styles.LoadingPanel>
        <Styles.LoadingImage src={loadingStepImage} alt="loading-banner" />
      </Styles.LoadingPanel>

      <Styles.LoadingProgressContainer>
        <Styles.TextWrapper>
          <Styles.LoadingTitle $isTransitioning={isTransitioning}>
            {loadingTitle}
          </Styles.LoadingTitle>
        </Styles.TextWrapper>

        <Styles.ProgressBarContainer>
          <ProgressBar
            progress={loadingProgress}
            progressWithBorderRadius
            size={mobile ? 'md' : 'lg'}
            color="gradientGreenBlue"
          />
        </Styles.ProgressBarContainer>
      </Styles.LoadingProgressContainer>
    </Styles.LoadingWrapper>
  );
};

export default LoadingContent;
